import { StyleSheet } from "react-native";
import { useMemo } from "react";
import { useDimensionsContext } from "contexts";

//! Components that utilize this need to be wrapped in
// ViewWithDimensionsContext
export const useHabitGridStyles = () => {
  const { width, getScaledFontSize } = useDimensionsContext();

  const COLUMN_WIDTH = Math.min((width * 61) / 360, 80);
  //this means we are showing 3.7 habit grid items on screen
  const GRID_LEFT_WIDTH = Math.min(width - 3.7 * COLUMN_WIDTH + 1, 320);

  return {
    COLUMN_WIDTH,
    GRID_LEFT_WIDTH,
    fontSize: getScaledFontSize(0.86),
    styles: useMemo(
      () =>
        StyleSheet.create({
          column: {
            width: COLUMN_WIDTH,
          },
          dataCell: {
            height: COLUMN_WIDTH,
            width: COLUMN_WIDTH,
          },
          spacerBlock: {
            height: COLUMN_WIDTH * 0.85 - 1,
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
          },
          headerCell: {
            height: COLUMN_WIDTH * 0.85,
            justifyContent: "center",
            alignItems: "center",
          },
          day: {
            height: COLUMN_WIDTH - 4,
            width: COLUMN_WIDTH - 4,
            marginTop: 2,
            borderRadius: 0,
            justifyContent: "center",
            alignItems: "center",
            // So that the first cell is up against edge of screen instead of padding
            alignSelf: "flex-end",
          },
        }),
      [COLUMN_WIDTH]
    ),
  };
};
